import { FC, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Textarea,
} from '@chakra-ui/react';
import { CreateLeadActionDto } from '../../types';

export interface CreateActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateLeadActionDto) => Promise<void>;
  initialData?: Partial<CreateLeadActionDto>;
}

export const CreateActionModal: FC<CreateActionModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
}) => {
  const [title, setTitle] = useState(initialData?.title || '');
  const [description, setDescription] = useState(initialData?.description || '');
  const [scheduledAt, setScheduledAt] = useState(
    initialData?.scheduled_at || new Date().toISOString().slice(0, 16)
  );
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!title || !scheduledAt) return;

    setLoading(true);
    try {
      await onSubmit({
        title,
        description: description || undefined,
        scheduled_at: new Date(scheduledAt).toISOString(),
      });
      setTitle('');
      setDescription('');
      setScheduledAt(new Date().toISOString().slice(0, 16));
      onClose();
    } catch (error) {
      console.error('Failed to create action:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Action</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Title</FormLabel>
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g., Contact next Thursday"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Additional details..."
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Scheduled At</FormLabel>
              <Input
                type="datetime-local"
                value={scheduledAt}
                onChange={(e) => setScheduledAt(e.target.value)}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

